
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/background-remover",
      function () {
        return require("private-next-pages/background-remover/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/background-remover"])
      });
    }
  